import _ from 'lodash';
import { postSaveActivityForm } from '../utils';

function _postAutosave(state) {
    return postSaveActivityForm('/home/autosave', state);
}

function _setLocalStorage({ permitValidated, permitNumber, permitYear, facilityUsages, email, zeroFacilityUsagesReport, isZeroFacilityUsagesReportSubmission }) {
    if (window.localStorage) {
        window.localStorage.setItem(`__prksusg__${permitNumber}__${permitYear}__`, JSON.stringify({
            permitValidated,
            permitNumber,
            permitYear,
            facilityUsages,
            email,
            zeroFacilityUsagesReport,
            isZeroFacilityUsagesReportSubmission,
            createdTimestamp: Date.now()
        }));
    }
}

const _storeChangeCallback = (mutation, state) => {
    const { permitValidated, permitNumber, permitYear, shouldAutosave } = state;
    const facilityMutations = ['addFacilityUsage', 'removeFacilityUsage', 'updateFacilityUsage', 'setFacilityUsages', 'setEmail', 'setZeroFacilityUsagesReport', 'setIsZeroFacilityUsagesReportSubmission'];

    if (facilityMutations.includes(mutation.type) && permitValidated && permitNumber && permitYear && shouldAutosave) {

        if (mutation.type === 'setEmail') {
            _.debounce(() => {
                //if (window.localStorage) {
                //    _setLocalStorage(state);
                //}
                //else {
                //    _postAutosave(state);
                //}

                _postAutosave(state);
            }, 1000)();
        }
        //else if (window.localStorage) {
        //    _setLocalStorage(state);
        //}
        else {
            _postAutosave(state);
        }
    }
};

const localStoragePlugin = store => store.subscribe(_storeChangeCallback);

export default [
    localStoragePlugin
];